// extracted by mini-css-extract-plugin
export var testimonial = "styles-module--testimonial--IInrU";
export var bigImageWrapper = "styles-module--bigImageWrapper--3c9v9";